import styled, { css } from 'styled-components';
import { COLORS } from 'components/containers/Theme/defaults';
import { getThemeFontSize } from 'utilities';

export const ModalWrapper = styled.div`
  background: ${COLORS.WHITES[1]};
  padding: 20px 30px;
  border-radius: 2px;

  ${({ isMobile }) =>
    isMobile &&
    css`
      padding: 20px;
    `};
`;

export const ModalTitle = styled.h1`
  font-size: ${getThemeFontSize('large')};
  color: ${COLORS.BLACKS[1]};
  font-weight: 700;
`;
